export { Laptop as default } from './Laptop';
